export enum PromotionType {

    PROTECTED = 1,
    SPREAD_CASHBACK = 2,
    POSITION_INSURANCE = 3,
    ROLLOVER_DISCOUNT = 4,
}
